var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EqsTextDisplay',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('user.profile.current-profile.delete-user', { universeMail: _vm.universeMail, universe: _vm.universe }))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }